
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen?: boolean;
}

const FAQItem = ({ question, answer, isOpen = false }: FAQItemProps) => {
  const [isExpanded, setIsExpanded] = useState(isOpen);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="border border-gold/20 rounded-lg overflow-hidden bg-white">
      <button
        className={`w-full text-left py-4 px-6 font-montserrat font-semibold text-primary flex justify-between items-center transition-colors hover:text-accent focus:outline-none focus:ring-2 focus:ring-accent/20 focus:ring-inset ${
          isExpanded ? 'bg-neutral-tan/30' : ''
        }`}
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <span>{question}</span>
        {isExpanded ? <ChevronUp className="flex-shrink-0 text-gold" /> : <ChevronDown className="flex-shrink-0 text-gold" />}
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ${
          isExpanded ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="p-6 pt-2 text-text/80 font-montserrat">
          {answer}
        </div>
      </div>
    </div>
  );
};

export default FAQItem;
